import { render, staticRenderFns } from "./MainLayout.vue?vue&type=template&id=1a2bc83d&scoped=true&"
import script from "./MainLayout.vue?vue&type=script&lang=js&"
export * from "./MainLayout.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/common.css?vue&type=style&index=0&lang=css&"
import style1 from "@/assets/css/company.css?vue&type=style&index=1&id=1a2bc83d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2bc83d",
  null
  
)

export default component.exports